import axios from 'axios';
import config from '@/config';

export default () => axios.create({
  baseURL: `http${config.server.ssl ? 's' : ''}://${config.server.host}:${config.server.port}/`,
});
